import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { TokenResponse } from "../models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  isAuthentication: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor() {
    const token = this.getToken();
    if (token) {
      this.setAuthSate(true);
    }
  }

  getToken(): string | null {
    return localStorage.getItem('AUTH_TOKEN');
  }

  setToken(token: TokenResponse | null): void {
    if (token) {
      const credentialsBase64 = btoa(`${token.username}:${token.password}`);
      this.setAuthSate(true);
      localStorage.setItem('AUTH_TOKEN', credentialsBase64);
    }
  }

  setAuthSate(status: boolean) {
    this.isAuthentication.next(status);
  }

  removeToken() {
    this.setAuthSate(false);
    localStorage.removeItem('AUTH_TOKEN');
    localStorage.removeItem('X-CSRF-TOKEN');
  }

}
